module.exports = "/img/service-3.07574e36.png";